import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "relative px-24 text-mine-shaft md:z-1 xl:px-64" }
const _hoisted_3 = { class: "flex justify-end mb-32" }
const _hoisted_4 = { class: "md:w-1/4" }
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 1,
  class: "block italic mt-15"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["href"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { class: "flex flex-col mt-15 ml-10 md:ml-0" }
const _hoisted_13 = {
  key: 0,
  class: "mt-x1"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "mt-15"
}
const _hoisted_16 = { class: "mt-30 flex flex-col-reverse md:flex-row md:items-center" }
const _hoisted_17 = {
  key: 0,
  class: "md:w-1/4 md:pr-20"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 1,
  class: "mb-20 md:mb-0 md:w-1/4 md:pr-20"
}
const _hoisted_21 = ["src", "alt"]
const _hoisted_22 = {
  key: 2,
  class: "mb-20 md:mb-0 md:w-1/4 md:pr-20"
}
const _hoisted_23 = ["src", "title"]
const _hoisted_24 = { class: "mb-20 md:mb-0 md:w-1/4" }
const _hoisted_25 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_26 = { class: "inline-block mr-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BlockList = _resolveComponent("BlockList")!
  const _component_ScrollToTopButton = _resolveComponent("ScrollToTopButton")!
  const _component_PageFooterAccordion = _resolveComponent("PageFooterAccordion")!
  const _component_RouterLinkConditional = _resolveComponent("RouterLinkConditional")!
  const _component_LogoutLink = _resolveComponent("LogoutLink")!
  const _component_Breakpoints = _resolveComponent("Breakpoints")!
  const _component_TrustpilotMiniWidget = _resolveComponent("TrustpilotMiniWidget")!
  const _component_router_link_conditional = _resolveComponent("router-link-conditional")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasFooterTiles)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createVNode(_component_BlockList, {
            blocks: _ctx.footer.tiles
          }, null, 8, ["blocks"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("footer", {
      class: "bg-brandy py-19",
      style: _normalizeStyle({ 'background-color': _ctx.footer.backGroundColorHexCode })
    }, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_ScrollToTopButton, {
              text: _ctx.$dictionary.get('b2c/footer/scrolltotoplink')
            }, null, 8, ["text"])
          ])
        ]),
        _createVNode(_component_Breakpoints, null, {
          "max-sm": _withCtx(() => [
            _createVNode(_component_PageFooterAccordion, { footer: _ctx.footer }, null, 8, ["footer"])
          ]),
          "min-md": _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer.columns, (footerColumn, idx) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: footerColumn.headerLink.url+idx,
                  class: "w-1/4 pr-20 last:pr-0"
                }, [
                  _createVNode(_component_RouterLinkConditional, {
                    to: footerColumn.headerLink.url,
                    class: "o-text-h3 c-magic-line my-0",
                    title: footerColumn.headerLink.title || footerColumn.headerLink.text,
                    target: footerColumn.headerLink.target,
                    "spa-enabled": footerColumn.headerLink.spaLink
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(footerColumn.headerLink.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "title", "target", "spa-enabled"]),
                  (footerColumn.freeText)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "italic mt-15",
                        innerHTML: footerColumn.freeText
                      }, null, 8, _hoisted_6))
                    : _createCommentVNode("", true),
                  (_ctx.isLastColumn(idx) && (_ctx.footer.phone || _ctx.footer.email))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_ctx.footer.phone)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                              _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/footer/phone')) + ": ", 1),
                              _createElementVNode("a", {
                                href: 'phone:'+_ctx.footer.phone
                              }, _toDisplayString(_ctx.footer.phone), 9, _hoisted_9)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.footer.email)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                              _createTextVNode(_toDisplayString(_ctx.$dictionary.get('b2c/footer/email')) + ": ", 1),
                              _createElementVNode("a", {
                                href: 'mailto:'+_ctx.footer.email
                              }, _toDisplayString(_ctx.footer.email), 9, _hoisted_11)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(footerColumn.links, (columnLink, subIdx) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: columnLink.url+subIdx,
                        class: "mb-8"
                      }, [
                        _createVNode(_component_RouterLinkConditional, {
                          to: columnLink.url,
                          target: columnLink.target,
                          title: columnLink.title || columnLink.text,
                          class: "c-magic-line lg:my-0"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(columnLink.text), 1)
                          ]),
                          _: 2
                        }, 1032, ["to", "target", "title"])
                      ]))
                    }), 128)),
                    (_ctx.isLastColumn(idx))
                      ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                          _createElementVNode("p", {
                            class: "whitespace-pre",
                            innerHTML: _ctx.footer.legalCodes
                          }, null, 8, _hoisted_14)
                        ]))
                      : _createCommentVNode("", true),
                    (idx === 0 && _ctx.shouldShowLogout)
                      ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                          _createVNode(_component_LogoutLink, { class: "c-magic-line md:my-0" })
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_16, [
          (_ctx.footer.trustpilotWidgetModel || _ctx.footer.copyrightText)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                (_ctx.footer.trustpilotWidgetModel)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_TrustpilotMiniWidget, {
                        "business-unit-id": _ctx.footer.trustpilotWidgetModel.trustpilotBusinessUnitId,
                        "hex-code": _ctx.footer.backGroundColorHexCode
                      }, null, 8, ["business-unit-id", "hex-code"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.footer.copyrightText)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.footer.copyrightText), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.footer.socialMediaLinks)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer.socialMediaLinks, (link) => {
                  return (_openBlock(), _createBlock(_component_router_link_conditional, {
                    key: link.url,
                    class: "inline-block mr-20",
                    to: link.url,
                    "spa-enabled": link.spaLink,
                    title: link.title || link.text,
                    target: link.target
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        src: link.imageUrl,
                        alt: link.title,
                        class: "w-20"
                      }, null, 8, _hoisted_21)
                    ]),
                    _: 2
                  }, 1032, ["to", "spa-enabled", "title", "target"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.footer.paymentOptions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer.paymentOptions, (option) => {
                  return (_openBlock(), _createElementBlock("img", {
                    key: option.imageUrl,
                    src: option.imageUrl,
                    title: option.name,
                    class: "w-35 inline-block mr-5"
                  }, null, 8, _hoisted_23))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.footer?.findStoreLink.url)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("b", _hoisted_26, _toDisplayString(_ctx.$dictionary.get('b2c/footer/stores')), 1),
                  _createVNode(_component_router_link_conditional, {
                    class: "c-magic-line c-magic-line--underline inline-block",
                    to: _ctx.footer.findStoreLink.url,
                    "spa-enabled": _ctx.footer.findStoreLink.spaLink,
                    title: _ctx.footer.findStoreLink.title || _ctx.footer.findStoreLink.text,
                    target: _ctx.footer.findStoreLink.target
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.footer.findStoreLink.text), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "spa-enabled", "title", "target"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 4)
  ], 64))
}